import { action, payload } from "ts-action";
import { Dictionary, UserFilter, UserFilterId } from "../../globalTypes";
import { TableIdentifier } from "../tableData/types";
import { UserFilterDTO } from "../../requests/userFilters/types";
import { FilterPatch } from "../../requests/userFilters";

/* getAllFilters */
export const userFilterGetAllFiltersRequest = action(
  "USER FILTERS > GET ALL > REQUEST",
  payload<void>()
);

export const userFilterGetAllFiltersSuccess = action(
  "USER FILTERS > GET ALL > SUCCESS",
  payload<{ filters: Dictionary<UserFilterId, UserFilter> }>()
);

export const userFilterGetAllFiltersError = action(
  "USER FILTERS > GET ALL > ERROR",
  payload<void>()
);

/* Get filter for template id */
export const userFilterGetFiltersForTableRequest = action(
  "USER FILTERS > GET FOR TABLE > REQUEST",
  payload<{ identifier: TableIdentifier }>()
);

export const userFilterGetFiltersForTableSuccess = action(
  "USER FILTERS > GET FOR TABLE > SUCCESS",
  payload<{
    identifier: TableIdentifier;
    filters: Dictionary<UserFilterId, UserFilter>;
  }>()
);

export const userFilterGetFiltersForTableError = action(
  "USER FILTERS > GET FOR TABLE > ERROR",
  payload<{ identifier: TableIdentifier }>()
);

/* Get filter by id */
export const userFilterGetFilterByIdRequest = action(
  "USER FILTERS > GET FILTER BY ID > REQUEST",
  payload<{ filterId: number }>()
);

export const userFilterGetFilterByIdSuccess = action(
  "USER FILTERS > GET FILTER BY ID > SUCCESS",
  payload<{ filterId: number; filter: UserFilter }>()
);

export const userFilterGetFilterByIdError = action(
  "USER FILTERS > GET FILTER BY ID > ERROR",
  payload<{ filterId: number }>()
);

/* Post new filter */
export const userFilterPostNewFilterRequest = action(
  "USER FILTERS > POST NEW FILTER > REQUEST",
  payload<{ filter: UserFilter }>()
);

export const userFilterPostNewFilterSuccess = action(
  "USER FILTERS > POST NEW FILTER > SUCCESS",
  payload<{ filter: UserFilter }>()
);

export const userFilterPostNewFilterError = action(
  "USER FILTERS > POST NEW FILTER > ERROR",
  payload<void>()
);

/* Delete filter */
export const userFilterDeleteFilterRequest = action(
  "USER FILTERS > DELETE FILTER > REQUEST",
  payload<{ filterId: number }>()
);

export const userFilterDeleteFilterSuccess = action(
  "USER FILTERS > DELETE FILTER > SUCCESS",
  payload<{ filterId: number }>()
);

export const userFilterDeleteFilterError = action(
  "USER FILTERS > DELETE FILTER > ERROR",
  payload<{ filterId: number; oldFilter?: UserFilter }>()
);

/* Edit filter */
export const userFilterPutFilterRequest = action(
  "USER FILTERS > PUT FILTER > REQUEST",
  payload<{ filterId: number; filter: UserFilter }>()
);

export const userFilterPutFilterSuccess = action(
  "USER FILTERS > PUT FILTER > SUCCESS",
  payload<{ filterId: number; filter: UserFilter }>()
);

export const userFilterPutFilterError = action(
  "USER FILTERS > PUT FILTER > ERROR",
  payload<{ filterId: number; oldFilter?: UserFilter }>()
);

export const userFilterPatchFilterRequest = action(
  "USER FILTERS > PATCH FILTER > REQUEST",
  payload<{
    filterId: number;
    partialFilter: FilterPatch;
    resetValue?: keyof UserFilterDTO[];
  }>()
);

export const userFilterPatchFilterSuccess = action(
  "USER FILTERS > PATCH FILTER > SUCCESS",
  payload<{ filterId: number }>()
);

export const userFilterPatchFilterError = action(
  "USER FILTERS > PATCH FILTER > ERROR",
  payload<{ filterId: number; oldFilter?: UserFilter }>()
);
